<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import type { ButtonSize, SizeConditional } from '#imports';
interface IProps {
    size?: SizeConditional<ButtonSize>;
    unit: string;
    minTitle?: string;
    min?: number;
    max?: number;
    startButton?: boolean;
    startButtonIcon?: IconDefinition;
    startIconButton?: boolean;
    label?: string;
    desktopRow?: boolean;
    labelClass?: string;
    autoWidth?: boolean;
    disabled?: boolean;
}
const {
    size = 'medium',
    min = 0,
    max = 10,
    startButtonIcon = faPlus,
    label = '',
    labelClass = '',
    startIconButton,
    desktopRow,
    minTitle,
    unit,
    startButton,
    autoWidth,
    disabled,
} = defineProps<IProps>();

const emit = defineEmits<{
    increase: [];
    decrease: [];
}>();
const modelValue = defineModel<number>({ default: 0 });

const actualMinTitle = computed(() => minTitle || `افزودن ${unit}`);

const increase = () => {
    modelValue.value++;
    emit('increase');
};
const decrease = () => {
    modelValue.value--;
    emit('decrease');
};
</script>

<template>
    <div
        class="counter-container"
        :class="{ 'desktop-row': desktopRow, auto: autoWidth }"
    >
        <label v-if="label" class="counter-label" :class="labelClass">
            {{ label }}
        </label>
        <mr-button
            v-if="startButton && modelValue === min"
            full-width
            :disabled
            :size
            :right-icon="startIconButton ? undefined : startButtonIcon"
            :icon-button="startIconButton ? startButtonIcon : undefined"
            @click="increase"
        >
            {{ actualMinTitle }}
        </mr-button>
        <div v-else class="counter">
            <mr-button
                :icon-button="faMinus"
                :disabled="modelValue <= min"
                :size
                @click="decrease"
            />
            <p class="counter-value" :class="{ zero: modelValue === 0 }">
                {{ modelValue }} {{ unit }}
            </p>
            <mr-button
                :icon-button="faPlus"
                :disabled="modelValue === max"
                :size
                @click="increase"
            />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.counter-container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    background-color: transparent;
    width: 100%;
    border-radius: 8px;
    &.auto {
        width: auto;
    }

    &.desktop-row {
        @include desktop-only {
            flex-direction: row;
            align-items: center;
            .counter-label {
                flex: 1 0 40%;
                margin: 0;
            }
            .counter {
                flex: 1 0 60%;
            }
        }
    }
    .counter-label {
        @include tg-m($w5);
        white-space: nowrap;
        margin: 0 0 8px 0;
    }

    .counter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-radius: 8px;
        gap: 16px;
        .counter-value {
            @include tg-l($w5, usePalette());
            margin: 0;
            &.zero {
                color: usePalette($p-cool-gray, $p-600);
            }
            white-space: nowrap;
        }
    }
}
</style>
